export default __webpack_public_path__ + "media/src/assets/images/storage-56ec3edfecb3403e34688c937ffa8d8d.png";